import { PROVIDERS } from "modules/auth/constants";
import { signInWithProvider } from "../socialAuth";
import createProvider from "./createProvider";
import signInWithLinkedin from "./signInWithLinkedin";

export const getCallbackUrl = (providerName: PROVIDERS) =>
  `//${window.location.host}/${providerName}/callback`;

interface Options {
  usePopup?: boolean;
  prefilledEmail?: string;
}

export default async (
  providerName: PROVIDERS,
  { usePopup = false, prefilledEmail }: Options = {},
) => {
  switch (providerName) {
    case PROVIDERS.FACEBOOK:
    case PROVIDERS.GOOGLE:
    case PROVIDERS.MICROSOFT:
      return signInWithProvider(
        createProvider(providerName, { prefilledEmail }),
        usePopup,
      );
    case PROVIDERS.LINKEDIN:
      if (!usePopup) {
        throw new Error(
          "Only popup method is supported for linkedin in this host",
        );
      }

      return signInWithLinkedin();
    default:
      throw new Error(
        `Trying to sign in with unknown provider "${providerName}"`,
      );
  }
};
